import { SetState, GetState } from 'zustand';
import { MoveMoneySteps, MoveMoneyTypes } from '../pages/MoveMoney/consts';
import { ISupplierModel } from '../pages/Supplier/types';
import { IMoveMoneyLimits } from '../pages/MoveMoney/api/getWireLimits';
import { IWireFees } from '../pages/MoveMoney/api/getWireFees';
import { IMoveMoneyReviewResponse } from '../types';
import { IAchOutFees } from '../pages/MoveMoney/api/getAchOutFees';
import { TRANSFER_TYPES } from '../pages/MoveMoney/steps/Review';
import { IEddAnswers } from '../pages/MoveMoney/steps/InternationalWireEdd';

export interface IMoveMoneyData {
  amount: number;
  vendorData: ISupplierModel | undefined;
  supplierList: ISupplierModel[];
  moveType: MoveMoneyTypes | null;
  feeData: IWireFees | undefined;
  achOutFeeData: IAchOutFees | undefined;
  achOutTransferType: TRANSFER_TYPES;
  limitsData: IMoveMoneyLimits | undefined;
  billId: string;
  activeStepId: MoveMoneySteps;
  isEditMode: boolean;
  isEditModeFromAddressBook: boolean;
  isVendorUpdateMandatory: boolean;
  preFilledBusinessName: string;
  mfaChallengeData: IMoveMoneyReviewResponse | null;
  purposeOfTransfer: string;
  purposeOfTransferReason: string;
  eddAnswers: IEddAnswers | null;
  introRequired: boolean;
  eddRequired: boolean;
  eddVersion: string;
  purposes: string[];
  transferNote: string;
  isLoadingInitialData: boolean;
  isUpdateNameRequired: boolean;
}

export interface IMoveMoneySlice {
  moveMoneyData: IMoveMoneyData;
  setMoveMoneyData: (data: IMoveMoneyData) => void;
  resetMoveMoneyData: () => void;
  resetMoveMoneyDataForAnotherTransfer: () => void;
  getMoveMoneyData: () => IMoveMoneyData;
}

const initialState = {
  amount: 0,
  eddAnswers: null,
  vendorData: undefined,
  supplierList: [],
  moveType: null,
  feeData: undefined,
  achOutFeeData: undefined,
  achOutTransferType: TRANSFER_TYPES.STANDARD,
  limitsData: undefined,
  billId: '',
  activeStepId: MoveMoneySteps.PRE_LOAD,
  isEditMode: false,
  isEditModeFromAddressBook: false,
  isVendorUpdateMandatory: false,
  preFilledBusinessName: '',
  mfaChallengeData: null,
  purposeOfTransfer: '',
  purposeOfTransferReason: '',
  introRequired: false,
  eddRequired: false,
  eddVersion: '',
  purposes: [],
  transferNote: '',
  isLoadingInitialData: false,
  isUpdateNameRequired: false,
};

const createMoneyMoveSlice = (set: SetState<IMoveMoneySlice>, get: GetState<IMoveMoneySlice>) => ({
  moveMoneyData: initialState,
  setMoveMoneyData: (data: IMoveMoneyData) => {
    set({ moveMoneyData: data });
  },
  resetMoveMoneyData: () => {
    set({ moveMoneyData: { ...initialState } });
  },
  resetMoveMoneyDataForAnotherTransfer: () => {
    const rawData = get().moveMoneyData;
    set({
      moveMoneyData: {
        ...rawData,
        amount: 0,
        billId: '',
        isEditMode: false,
        preFilledBusinessName: '',
        mfaChallengeData: null,
        introRequired: false,
        eddRequired: false,
        eddVersion: '',
        transferNote: '',
        isLoadingInitialData: false,
        purposeOfTransfer: '',
        purposeOfTransferReason: '',
        isUpdateNameRequired: false,
      },
    });
  },
  getMoveMoneyData: () => get().moveMoneyData,
});

export default createMoneyMoveSlice;
